import styled from "styled-components";

export const SidebarWrapper = styled.div`
  width: 240px;
  min-width: 240px;
  position: absolute;
  top: 0;
  left: 0;
  padding-right: 16px;
  background: transparent;
  z-index: 11;
  bottom: 0;
  transition: all .3s;

  ul {
    display: flex;
    flex-direction: column;
    gap: 6px;

    li {
      background: #fff;
      border: 1px solid #e8eee5;
      border-radius: 12px;
      display: flex;
      gap: 12px;
      align-items: center;
      height: 50px;
      padding: 0 16px;
      color: #1C2634;
      transition: all 0.25s;
      cursor: pointer;
      position: relative;
      overflow: hidden;

      > div {
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
        background: #f0f7ed;
        transition: all 0.25s;

        img {
          width: 17px;
          filter: brightness(0) saturate(100%) invert(45%) sepia(40%) saturate(560%) hue-rotate(70deg) brightness(95%) contrast(85%);
          transition: all 0.25s;
        }
      }

      span {
        display: block;
        font-size: 14px;
        font-weight: 600;
        width: 100%;
        visibility: visible;
        opacity: 1;
        white-space: nowrap;
      }

      &:hover {
        border-color: #509540;
        background: #f8fbf6;
        transform: translateX(3px);
        box-shadow: 0 4px 14px rgba(80,149,64,0.08);
      }

      &.active {
        background: linear-gradient(135deg, #509540, #3d7a30);
        border-color: #509540;
        color: #fff;
        box-shadow: 0 6px 18px rgba(80,149,64,0.30);

        > div {
          background: rgba(255,255,255,0.20);
          img { filter: brightness(0) invert(1); }
        }
      }
    }
  }

  &.close {
    min-width: 80px;
    width: 80px;
    overflow: hidden;
    transition: all .3s;

    ul li {
      justify-content: center;
      padding: 0;
      span {
        visibility: hidden;
        opacity: 0;
        display: none;
      }
    }

    @media only screen and (max-width: 768px) {
      min-width: 240px;
      width: 240px;
      left: -250px;
      overflow: hidden;
      ul li {
        justify-content: start;
        padding: 0 16px;
        span { display: block; visibility: visible; opacity: 1; }
      }
    }
  }
`;
